import React, { Component } from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';

class Empty extends Component {

  constructor (props) {
    super(props);

    this.state = {};
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  _handleClick = () => {
    const {onClick} = this.props;
    if (onClick) {
      onClick();
    }
  };

  render () {
    const {text, style} = this.props;
    return (
      <TouchableOpacity
        activeOpacity={0.75}
        onPress={this._handleClick}
        style={[styles.empty, style]}>
        <Text
          style={styles.emptyText}>
          {text}
        </Text>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  empty: {
    position: 'absolute',
    top: 0, left: 0, bottom: 0, right: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f6efdb',
  },
  emptyText: {
    margin: 12,
    color: '#ff0000',
    fontSize: 17,
    fontWeight: '500',
    backgroundColor: 'transparent',
  },
});

export default Empty;



// WEBPACK FOOTER //
// ./src/common/Empty.js